import { css } from 'lit';

var css_248z = css`:host .sgds.card[variant*=card-action] .card-body ::slotted(svg){margin-right:1rem}`;

export { css_248z as default };
//# sourceMappingURL=sgds-action-card2.js.map
